import { render, staticRenderFns } from "./glovo_review_params.vue?vue&type=template&id=319f0fb4&scoped=true&"
import script from "./glovo_review_params.vue?vue&type=script&lang=js&"
export * from "./glovo_review_params.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319f0fb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('319f0fb4')) {
      api.createRecord('319f0fb4', component.options)
    } else {
      api.reload('319f0fb4', component.options)
    }
    module.hot.accept("./glovo_review_params.vue?vue&type=template&id=319f0fb4&scoped=true&", function () {
      api.rerender('319f0fb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/review/location/providers/glovo_review_params.vue"
export default component.exports